module.exports = __webpack_public_path__ + "static/media/arrow.422a11ae.svg";